// components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const webhookUrl = process.env.REACT_APP_N8N_WEBHOOK_URL;

      if (!webhookUrl || webhookUrl.includes('your-endpoint')) {
        console.warn('n8n Webhook URL not configured. Falling back to console log for development.');
        console.log('Contact Form Data:', formData);
        alert('Form submission simulated in development mode.');
        setFormData({ name: '', email: '', message: '' });
        return;
      }

      const payload = {
        type: 'contact',
        ...formData,
        submittedAt: new Date().toISOString()
      };

      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Failed to send message');

      alert('Message sent. We will get back to you shortly.');
      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      console.error('Contact submission error:', err);
      alert('Sending failed. Please try again or email suit360abuja@gmail.com directly.');
    }
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Contact Us</h2>
      <div className="contact-content">
        <div className="contact-info">
          <h3>Contact Details</h3>
          <p><i className="fas fa-info-circle"></i> We are available to assist you throughout your stay. The best way to reach us is through the Airbnb messaging platform, or you can contact us directly via phone. We aim to respond promptly to all questions or concerns.</p>
          <p><i className="fas fa-map-marker-alt"></i> Address: Abuja, Federal Capital Territory, Nigeria</p>
          <p><i className="fas fa-envelope"></i> Email: <a href="mailto:suit360abuja@gmail.com">suit360abuja@gmail.com</a></p>
          <p><i className="fas fa-phone-alt"></i> Phone: <a href="tel:+2349168126753">+234 916 812 6753</a></p>
          <div className="social-links">
            <a href="https://www.facebook.com/share/12L7c92CDkU/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://instagram.com/suite360abuja" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
        <div className="contact-form-container">
          <h3>Send Us a Message</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required></textarea>
            </div>
            <button type="submit" className="btn-primary">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
